module.exports = __webpack_public_path__ + "static/media/logo.a11d9e9b.gif";